import React, {useContext, useState, useEffect} from 'react'
import t from 'helpers/I18n'
import {useParams} from "react-router";
import {useHistory} from "react-router-dom";

import {AppDataContext} from 'contexts/app-data'
import { personal_info_steps_config, legal_info_steps_config, pro_info_steps_config } from "steps/steps-config";
import { BASE_URL } from '../../env';
import getCookie from '../../functions/getcookie';
import deleteCookie from '../../functions/deleteCookie';
import StepsWrapper from "steps/steps-wrapper";
import EndFlow from "steps/end-flow";
import HasEnterprise from "steps/pro-info/has-enterprise";
import EnterpriseNumber from "steps/pro-info/enterprise-number"
import EnterpriseName from "steps/pro-info/enterprise-name"
import HasEnterpriseName from "steps/pro-info/has-enterprise-name"
import EstablishmentDate from "steps/pro-info/establishment-date"
import HasEstablishmentDate from "steps/pro-info/has-establishment-date"
import Nace from './pro-info/nace';
import EnterpriseCountry from './pro-info/enterprise-country';
import SummaryProStep from './pro-info/pro-step-summary';
import getStep from '../../helpers/getStep';
import { string } from 'prop-types';


const ProSteps = () => {
    const {state, dispatch} = useContext(AppDataContext)
    const [error, setError ] = useState([])
    const history = useHistory();
    const getKeyByValue = (object, value) => ( Object.keys(object).find(key => object[key].step_position === value))
    const getDataFromContext = (step_ID) => (state.raw_pro_data[step_ID])
    const { id, locale } = useParams()
    const lang = localStorage.getItem('language')

    const base_URL = `${BASE_URL}/onboarding-entrepreneur-front/v1/step`
    const fetch_init_options = {
        method: 'POST',
        credentials: "include",
        mode: "cors",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',            
        }
    }
    const fetch_get_init_options = {
        method: 'GET',
        credentials: "include",
        mode: "cors",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',            
        }
    }

    const errorsHandeling = function (response) {
        const backendError = JSON.parse(response.message)
        const finalErr = backendError.map(error => ({id: error.id, error: t(`error_messages.${error.error}`)}))
        setError(finalErr)
    }

    const _step_service = function ({ step_ID, setIsLoading, next_step }) {
        const fetch_url = base_URL
        const stepFieldData = getDataFromContext(step_ID)
        console.log(step_ID)
        console.log("stepFieldData = ", stepFieldData)
        let data = []

        for (let field in stepFieldData) {
            !field.startsWith("__") && stepFieldData[field] !== null && 
            data.push({
                "fieldId": field,
                "fieldValue": stepFieldData[field] 
            })
        }

        setIsLoading(true)
        const fetch_init = {
            ...fetch_init_options,
            body: JSON.stringify(
            [...data]
            )
        }

        fetch(fetch_url, fetch_init).catch( error => {
            console.log("error : "+ error)
        }).then(response => {
            if (response.status === 200) return {status: 200}
            if (response.status === 400) return response.json()
        }).then(response => {
            if (response.status === 400 ) {
                if (getCookie('sf-payload-ident')) {
                    deleteCookie()
                    // history.push('/')
                    // window.location.href = window.location.origin
                           window.location.href = (`${window.location.origin}/${lang.toLowerCase()}/404`)

                } else if (getCookie('sf-payload-ident') === undefined) (
                    // window.location.href = window.location.origin
                           window.location.href = (`${window.location.origin}/${lang.toLowerCase()}/404`)

                    // history.push('/')
                )
                errorsHandeling(response)
                setIsLoading(false)
            }
            if (response.status === 200) {
                setTimeout(function(){
                    // setIsLoading(false)
                    history.push(next_step)
                    
                }, 100)
            }
        })
    }

    const _get_step_service = function (field) {
        const fetch_url = base_URL

        const fetch_init = {
            ...fetch_get_init_options,
        }

            fetch(`${fetch_url}/${field}`, fetch_init).catch( error => {
                console.log("error : "+ error)
            }).then(response => {
                if (response.status === 200) return {status: 200}
                if (response.status === 400) return response.json()
            }).then(response => {
                if (response.status === 400) {
                    errorsHandeling(response)
                }
                if (response.status === 200) {
                    console.log('response from serveur', response)
                }
            })   
    }

    const setDataToContext = (step_ID, step_URL, name, value) => {
            dispatch({
                type: 'SET_RAW_PRO_DATA',
                step: {step_ID, step_URL, step_position},
                value: {[name] : value}
            })
        }

    const steps = pro_info_steps_config.steps
    const step_info = steps[id]
        if (step_info === undefined) {
        window.location.href = (`${window.location.origin}/${lang.toLowerCase()}/404`);
    }
    const {step_position, step_ID, step_URL, step_form} = step_info

    const total_steps = Object.keys(steps).length + Object.keys(legal_info_steps_config.steps).length + Object.keys(personal_info_steps_config.steps).length
    const loaded = id === "end-flow" ? 0.1 :(step_position / total_steps) * 100
    const stepGroupTitle = id === 'end-flow' ? t("exit_messages.header_title") : t('pro_infos.title')
    const step_URL_baseName = `/${locale}/pro-steps/`

    const step_init = {
        getStep,
        step_ID,
        step_position,
        step_form,
        error,
        step_URL : step_URL_baseName + step_URL,
        next_step : step_position >= 1 && step_position < total_steps ? `${step_URL_baseName}${steps[getKeyByValue(steps, step_position + 1)].step_URL}` : "/",
        _step_service,
        _get_step_service,
        getDataFromContext,
        setDataToContext
    }

        useEffect(() => {
        getStep([
            "enterprise_activity_country", "internal_entreprise_country_name","enterprise_activity_code", "internal_nace_name", "has_enterprise", "enterprise_name", "enterprise_name_use_fullname", "establishment_date", "enterprise_number"
        ]).then(res => { 
            res["enterprise_number"] !== "NULL" && setDataToContext("enterprise_number", "", "enterprise_number",  res["enterprise_number"]);
            res["internal_entreprise_country_name"] !== "null" && setDataToContext("enterprise_activity_country", "", "internal_entreprise_country_name",  JSON.parse(res["internal_entreprise_country_name"]));
            res["enterprise_activity_country"] !== "null" && setDataToContext("enterprise_activity_country", "", "enterprise_activity_country", res["enterprise_activity_country"]);
            res["enterprise_name"] !== "NULL" && setDataToContext("enterprise_name", "", "enterprise_name",  res["enterprise_name"]);
            res["enterprise_name_use_fullname"] !== "-1" && typeof res["enterprise_name_use_fullname"] !== "string" && setDataToContext("enterprise_name", "", "enterprise_name_use_fullname",  Number(res["enterprise_name_use_fullname"]));
            res["has_enterprise"] !== "NULL" && setDataToContext("has_enterprise", "", "has_enterprise",  res["has_enterprise"]);
            res["enterprise_activity_code"] !== "NULL" && setDataToContext("enterprise_activity_code", "", "enterprise_activity_code",  res["enterprise_activity_code"]);
            res["enterprise_activity_code"] !== "NULL" && setDataToContext("enterprise_activity_code", "", 'internal_nace_selectionTree',  res["enterprise_activity_code"]);
            res["internal_nace_name"] !== "null" && setDataToContext("enterprise_activity_code", "", 'internal_nace_name',  res["internal_nace_name"]);
            res["establishment_date"] !== "null" && setDataToContext("establishment_date", "", 'establishment_date',  res["establishment_date"]);
        })
  
    }, [])

    return(
        // <StepsWrapper loaded={loaded} stepGroupTitle={stepGroupTitle} title={t('general.open_vue_pro_account')}>
        <StepsWrapper loaded={loaded} stepGroupTitle={stepGroupTitle} >
            {id === "has-enterprise" && <HasEnterprise {...step_init} />}
            {id === "enterprise-number" && <EnterpriseNumber {...step_init} />}
            {id === "enterprise-name" && <EnterpriseName {...step_init} />}
            {id === "has-enterprise-name" && <HasEnterpriseName {...step_init} />}
            {id === "establishment-date" && <EstablishmentDate {...step_init} />}
            {id === "has-establishment-date" && <HasEstablishmentDate {...step_init} />}
            {id === "enterprise-activity-code" && <Nace {...step_init} />}
            {id === "enterprise-activity-country" && <EnterpriseCountry {...step_init} />}
            {id === "pro-info-review" && <SummaryProStep {...step_init} />}
        </StepsWrapper>
    )
}


export default ProSteps



